import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactDayPicker from "react-day-picker";

export default class DayPicker extends Component {
    render() {

        const dayComponent = this.props.renderDay ? this.props.renderDay : this.renderDay;

        return (
            <Fragment>
                {this.props.calendarStyle && <style>{this.props.calendarStyle}</style>}
                <ReactDayPicker
                    renderDay={dayComponent}
                    {...this.props}
                />
            </Fragment>
        );
    }

    renderDay = (day) => {
        const date = day.getDate();
        return (
            <div className="daypicker__circle__color">
                <span className="daypicker__circle__number">{date}</span>
                <span className="daypicker__circle__overlay"></span>
            </div>
        );
    }
}

DayPicker.propTypes = {
    calendarStyle: PropTypes.string,
};
